var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Watch } from 'vue-property-decorator';
import RegexStr from "../../common/RegexStr";
import { ESendCodeType } from "../../enum/ESendCodeType";
import VueDialog from "../../interface/IVueDialog";
import ClientService from '../../api/ClientService';
import CommonService from '../../api/CommonService';
import CompanyService from "../../api/CompanyService";
import MsgDialog from './MsgDialog.vue';
import AddShopDialog from "./AddShopDialog.vue";
var phoneRegex = new RegExp(RegexStr.mobile);
var ACCOUNT_DATE_TYPE;
(function (ACCOUNT_DATE_TYPE) {
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["ADVANCE_PAYMENT"] = 10] = "ADVANCE_PAYMENT";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["DELIVERY_PAYMENT_ONLINE"] = 11] = "DELIVERY_PAYMENT_ONLINE";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["DELIVERY_PAYMENT_OFFLINE"] = 12] = "DELIVERY_PAYMENT_OFFLINE";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["DALIILY"] = 13] = "DALIILY";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["WEEKS"] = 14] = "WEEKS";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["MONTHLY_PAYMENT"] = 15] = "MONTHLY_PAYMENT";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["SEASON"] = 16] = "SEASON";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["OFFLINE_ADVANCE_PAYMENT"] = 17] = "OFFLINE_ADVANCE_PAYMENT";
})(ACCOUNT_DATE_TYPE || (ACCOUNT_DATE_TYPE = {}));
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.phone = '';
        _this.code = '';
        _this.invite_code = '';
        _this.group = null;
        _this.organ_id = null;
        _this.groups = [];
        _this.organList = [];
        _this.invite_code_list = [];
        _this.isValid = false;
        _this.timer = null;
        _this.remainTime = 60;
        _this.canGetCode = true;
        _this.bindCheckFlag = true;
        _this.areaList = [];
        _this.region_id = [];
        _this.customerName = '';
        _this.settlementList = [];
        _this.cooperate_time = [];
        _this.join_time = [];
        _this.operation_list = [];
        _this.clientLevel = [];
        _this.saleUser = [];
        _this.business_level = null;
        _this.account_date_options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
        _this.accountDateEnum = ACCOUNT_DATE_TYPE;
        _this.from_system = '1';
        _this.business_name = '';
        _this.business_phone = '';
        _this.business_city_id = null;
        _this.business_address = '';
        _this.cooperate_stime = '';
        _this.cooperate_etime = '';
        _this.operation_type_ids = [];
        _this.ap_account_id = '';
        _this.business_contact = '';
        _this.accountdatetype = 15;
        _this.accountdateval = '';
        _this.business_no = '';
        _this.edi_business_status = '0';
        _this.step = 1;
        _this.supplier_to_business_id = '';
        _this.is_franchisee = '0';
        _this.joinOpen = false;
        _this.business_tel_list = [{}];
        _this.day_week = [];
        _this.purchase_start_time = '';
        _this.purchase_end_time = '';
        _this.dayWeekOptions = [
            { name: '周一', id: 1 },
            { name: '周二', id: 2 },
            { name: '周三', id: 3 },
            { name: '周四', id: 4 },
            { name: '周五', id: 5 },
            { name: '周六', id: 6 },
            { name: '周日', id: 0 }
        ];
        _this.isOpenApAccountTypeBusiness = false;
        _this.shippingFeeList = [];
        _this.shipping_fee_dtid = '';
        _this.isOpenShippingFee = false;
        return _this;
    }
    AddDialog.prototype.fileListWatch = function (val, old) {
        if (val == ACCOUNT_DATE_TYPE.WEEKS) {
            this.account_date_options = [1, 2, 3, 4, 5, 6, 7];
            this.accountdateval = '';
        }
        else if (val == ACCOUNT_DATE_TYPE.MONTHLY_PAYMENT || val == ACCOUNT_DATE_TYPE.SEASON) {
            this.account_date_options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
            this.accountdateval = '';
        }
        else {
            this.account_date_options = [];
            this.accountdateval = '';
        }
    };
    AddDialog.prototype.created = function () {
        this.service = ClientService.getInstance();
        this.commonService = CommonService.getInstance();
        this.companyService = CompanyService.getInstance();
    };
    AddDialog.prototype.mounted = function () {
        this.getGroups();
        this.getArea();
        this.getOrganList();
        this.getOperationList();
        this.getSettlementList();
        this.getClientLevel();
        this.getSaleUser();
        this.getShippingFeeList();
    };
    AddDialog.prototype.sTimeBlur = function () {
        if (this.purchase_start_time) {
            this.purchase_start_time = this.purchase_start_time.replace('：', ':');
        }
        if (!this.purchase_start_time.includes(':')) {
            this.purchase_start_time = '00:00';
            return false;
        }
        if (this.purchase_start_time && !this.isTimeInRange(this.purchase_start_time)) {
            this.purchase_start_time = '00:00';
        }
    };
    AddDialog.prototype.eTimeBlur = function () {
        if (this.purchase_end_time) {
            this.purchase_end_time = this.purchase_end_time.replace('：', ':');
        }
        if (!this.purchase_end_time.includes(':')) {
            this.purchase_end_time = '23:59';
            return false;
        }
        if (this.purchase_end_time && !this.isTimeInRange(this.purchase_end_time)) {
            this.purchase_end_time = '23:59';
        }
        this.isEtimeValid();
    };
    AddDialog.prototype.isTimeInRange = function (time) {
        var regex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        return regex.test(time);
    };
    AddDialog.prototype.isEtimeValid = function () {
        if (!this.purchase_start_time || !this.purchase_end_time) {
            return true;
        }
        var _a = this.purchase_start_time.split(':').map(Number), sHour = _a[0], sMinute = _a[1];
        var _b = this.purchase_end_time.split(':').map(Number), eHour = _b[0], eMinute = _b[1];
        if (eHour < sHour || (eHour === sHour && eMinute <= sMinute)) {
            this.$message.warning("结束时间必须大于开始时间");
            return false;
        }
        return true;
    };
    AddDialog.prototype.getSaleUser = function () {
        var _this = this;
        this.service.getSaleUser().then(function (res) {
            _this.saleUser = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    AddDialog.prototype.getClientLevel = function () {
        var _this = this;
        this.service.getClientLevel().then(function (res) {
            _this.clientLevel = Array.isArray(res.data.data) ? res.data.data : [];
            _this.clientLevel.unshift({
                id: -1,
                name: '无等级'
            });
        });
    };
    AddDialog.prototype.getGroups = function () {
        var _this = this;
        this.service.getGroups().then(function (res) {
            var data = res.data.data;
            _this.groups = data || [];
            if (data && data.length) {
                _this.group = data[0].group_id;
            }
        });
    };
    AddDialog.prototype.getArea = function () {
        var _this = this;
        this.commonService.getArea().then(function (res) {
            var data = res.data;
            _this.areaList = data.data[0].children;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    AddDialog.prototype.getOrganList = function () {
        var _this = this;
        this.commonService.getOrganList().then(function (res) {
            var data = res.data.data;
            _this.organList = data || [];
            _this.organ_id = _this.organList.length ? _this.organList[0].organ_id : "";
        });
    };
    AddDialog.prototype.getSettlementList = function () {
        var _this = this;
        this.companyService.getSettlementList().then(function (res) {
            _this.settlementList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    AddDialog.prototype.getOperationList = function () {
        var _this = this;
        this.service.getOperationList().then(function (res) {
            if (res.data.success) {
                _this.operation_list = res.data.data;
            }
        });
    };
    AddDialog.prototype.getShippingFeeList = function () {
        var _this = this;
        this.service.getShippingFeeList().then(function (res) {
            if (res.data.success) {
                _this.shippingFeeList = res.data.data;
            }
        });
    };
    AddDialog.prototype.getShippingFeeName = function () {
        var _this = this;
        if (!this.shipping_fee_dtid || this.shipping_fee_dtid === 0 || this.shipping_fee_dtid === '0')
            return '';
        var shippingFee = this.shippingFeeList.find(function (item) { return item.dtid == _this.shipping_fee_dtid; });
        return shippingFee ? shippingFee.name : '';
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.closeAddClient = function () {
        this.$closeDialog();
        this.$emit('addClient:ok');
        this.$message.success('保存成功');
    };
    AddDialog.prototype.goAddShop = function () {
        var _this = this;
        var instance = this.$dialog(AddShopDialog, {
            data: {
                clientDetail: { 'business_name': this.business_name, 'supplier_to_business_id': this.supplier_to_business_id },
                addtype: 'addMulShop'
            }
        }, {
            title: "添加门店",
            width: 600,
            height: 410
        }).instance;
        instance.$on("addShop:ok", function () {
            _this.$emit('addClient:ok');
            _this.close();
        });
    };
    AddDialog.prototype.submitData = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (!res) {
                return false;
            }
            else {
                if (!_this.invite_code && _this.from_system == 1) {
                    _this.$message.error("请输入邀请码");
                    return;
                }
                ;
                if (_this.from_system == '4' && _this.day_week && _this.day_week.length > 0) {
                    if (!_this.purchase_start_time || !_this.purchase_end_time) {
                        _this.$message.error('选择了订货周期日，开始时间和结束时间不能为空');
                        return;
                    }
                    if (!_this.isEtimeValid()) {
                        return;
                    }
                }
                var params = null;
                var business_tel = '';
                if (_this.business_tel_list && _this.business_tel_list.length) {
                    var business_tel_list_1 = [];
                    _this.business_tel_list.forEach(function (item) {
                        if (item.business_tel_code && item.business_tel) {
                            business_tel_list_1.push(item.business_tel_code + '-' + item.business_tel);
                        }
                    });
                    business_tel = business_tel_list_1.join('、');
                }
                if (_this.from_system == 1) {
                    params = {
                        from_system: _this.from_system,
                        invite_code: _this.invite_code,
                        group_id: _this.group,
                        organ_id: _this.organ_id,
                        is_franchisee: _this.is_franchisee,
                        franchisee_stime: _this.join_time && _this.join_time.length > 0 && _this.join_time[0].format('yyyy-MM-dd'),
                        franchisee_etime: _this.join_time && _this.join_time.length > 0 && _this.join_time[1].format('yyyy-MM-dd'),
                        business_tel: business_tel,
                        business_level: _this.business_level,
                        ap_account_ids: _this.ap_account_id,
                        day_week: _this.day_week && _this.day_week.length > 0 ? _this.day_week.join(',') : '',
                        purchase_start_time: _this.purchase_start_time || '',
                        purchase_end_time: _this.purchase_end_time || '',
                        shipping_fee_dtid: (_this.shipping_fee_dtid && _this.shipping_fee_dtid !== '0') ? _this.shipping_fee_dtid : 0,
                        shipping_fee_dtid_name: _this.getShippingFeeName()
                    };
                }
                else {
                    params = {
                        group_id: _this.group,
                        organ_id: _this.organ_id,
                        from_system: _this.from_system,
                        business_name: _this.business_name,
                        business_phone: _this.business_phone,
                        business_city_id: _this.business_city_id,
                        business_address: _this.business_address,
                        cooperate_stime: _this.cooperate_time && _this.cooperate_time.length > 0 && _this.cooperate_time[0].format('yyyy-MM-dd'),
                        cooperate_etime: _this.cooperate_time && _this.cooperate_time.length > 0 && _this.cooperate_time[1].format('yyyy-MM-dd'),
                        operation_type_ids: (_this.operation_type_ids || []).join(','),
                        ap_account_ids: _this.ap_account_id,
                        business_contact: _this.business_contact,
                        accountdatetype: _this.accountdatetype,
                        accountdateval: _this.accountdateval,
                        business_no: _this.business_no,
                        edi_business_status: _this.edi_business_status,
                        is_franchisee: _this.is_franchisee,
                        franchisee_stime: _this.join_time && _this.join_time.length > 0 && _this.join_time[0].format('yyyy-MM-dd'),
                        franchisee_etime: _this.join_time && _this.join_time.length > 0 && _this.join_time[1].format('yyyy-MM-dd'),
                        business_tel: business_tel,
                        business_level: _this.business_level,
                        day_week: _this.day_week && _this.day_week.length > 0 ? _this.day_week.join(',') : '',
                        purchase_start_time: _this.purchase_start_time || '',
                        purchase_end_time: _this.purchase_end_time || '',
                        shipping_fee_dtid: (_this.shipping_fee_dtid && _this.shipping_fee_dtid !== '0') ? _this.shipping_fee_dtid : 0,
                        shipping_fee_dtid_name: _this.getShippingFeeName()
                    };
                }
                _this.service.addClient(params).then(function (res) {
                    if (res.data.code === 400004) {
                        var instance = _this.$dialog(MsgDialog, {
                            data: {
                                msgInfo: __assign({ msg: res.data.msg }, res.data.data)
                            }
                        }, {
                            title: "提示",
                            width: 420,
                            height: 250
                        }).instance;
                    }
                    else {
                        _this.step = 2;
                        _this.supplier_to_business_id = res.data.data.supplier_to_business_id;
                        _this.$message.success('客户添加成功！');
                        _this.$emit('addClient:ok');
                        if (_this.from_system == 1) {
                            _this.close();
                        }
                    }
                    ;
                }, function (err) {
                    _this.$message.error(err.message);
                }).catch(function (err) {
                    _this.$message.error(err.message);
                });
            }
        });
    };
    AddDialog.prototype.validatePhone = function () {
        var _this = this;
        var phoneRegex = /^1[23456789]\d{9}$/;
        if (phoneRegex.test(this.phone)) {
            this.commonService.bindCheck({ phone: this.phone }).then(function (res) {
                _this.bindCheckFlag = false;
            }, function (error) {
                _this.bindCheckFlag = true;
                _this.$message.error(error.message);
            });
        }
    };
    AddDialog.prototype.validateCode = function () {
        var _this = this;
        if (this.code.length > 6) {
            this.code = this.code.slice(0, 6);
        }
        if (this.code.length === 6) {
            this.commonService.verifyCode({ phone: this.phone, sms_code: this.code, type: ESendCodeType.add }).then(function (res) {
                _this.invite_code_list = res.data.data.invite_code_list;
                _this.isValid = true;
                _this.clearTimer();
            }, function (error) {
                _this.$message.error(error.message);
            });
        }
    };
    AddDialog.prototype.sendCode = function () {
        var _this = this;
        if (this.timer)
            return;
        if (!phoneRegex.test(this.phone)) {
            this.$message.error('手机号格式不正确！');
            return;
        }
        this.commonService.sendCode({ phone: this.phone, type: ESendCodeType.add }).then(function (res) {
            _this.$message.success('发送成功！');
        }, function (error) {
            _this.$message.error(error.message);
        });
        this.canGetCode = false;
        this.isValid = false;
        this.timer = setInterval(function () {
            _this.remainTime--;
            if (_this.remainTime === 0) {
                _this.clearTimer();
            }
        }, 1000);
    };
    AddDialog.prototype.clearTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
        this.remainTime = 60;
        this.canGetCode = true;
    };
    AddDialog.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    AddDialog.prototype.addTel = function () {
        this.business_tel_list.push({});
    };
    AddDialog.prototype.delTel = function (index) {
        this.business_tel_list.splice(index, 1);
    };
    __decorate([
        Watch("accountdatetype")
    ], AddDialog.prototype, "fileListWatch", null);
    AddDialog = __decorate([
        Component
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
